import React from 'react';

import Icon, { IconVariant } from 'components/Icon/Icon';
import Panel from 'components/Panel/Panel';

interface PlaceholderProps {
  title: string;
  description?: string;
  icon?: JSX.Element;
  children?: React.ReactNode;
}

const Placeholder = ({
  title,
  description,
  icon,
  children,
}: PlaceholderProps) => (
  <Panel panelClassName="bg-kira-slate-50 p-8">
    <div className="flex flex-col justify-center gap-4">
      {icon ? <Icon icon={icon} variant={IconVariant.LARGE} /> : null}
      <div className="flex flex-col justify-center gap-1">
        <div className="prose-title-h4 text-center">{title}</div>
        {description ? (
          <div className="prose-body-sm-reg text-center">{description}</div>
        ) : null}
      </div>
      {children}
    </div>
  </Panel>
);
export default Placeholder;
